import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";
import Question from "../../containers/question/";
import {
  dataToJS,
  isLoaded,
  pathToJS,
  firebaseConnect
} from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";
import CKEditor from "react-ckeditor-wrapper";
class EditResource extends Component {
  constructor(props) {
    super(props);

    this.updateContent = this.updateContent.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
    this.updateHS = this.updateHS.bind(this);
    this.updateUG = this.updateUG.bind(this);
    this.updateMS = this.updateMS.bind(this);
    this.save = this.save.bind(this);
    this.state = {};
  }

  updateContent(value) {
    this.setState({ content: value });
  }

  updateTitle(event) {
    this.setState({ title: event.target.value });
  }
  updateHS(event) {
    this.setState({ highschool: event.target.checked });
  }
  updateUG(event) {
    this.setState({ undergrad: event.target.checked });
  }
  updateMS(event) {
    this.setState({ gradstudent: event.target.checked });
  }

  componentWillReceiveProps(props) {
    if (props.resource)
      this.state = {
        title: props.resource.title,
        content: props.resource.content,

        highschool: props.resource.isActive &&
          props.resource.isActive.highschool,
        undergrad: props.resource.isActive && props.resource.isActive.undergrad,
        gradstudent: props.resource.isActive &&
          props.resource.isActive.gradstudent
      };
  }

  save() {
    if (this.props.match.params.resourceId === "0") {
      this.props.firebase.push("/resources", {
        title: this.state.title,
        content: this.state.content,
        isActive: {
          highschool: this.state.highschool || false,
          undergrad: this.state.undergrad || false,
          gradstudent: this.state.gradstudent || false
        }
      });
    } else {
      this.props.firebase.set(
        `/resources/${this.props.match.params.resourceId}`,
        {
          title: this.state.title,
          content: this.state.content,
          isActive: {
            highschool: this.state.highschool || false,
            undergrad: this.state.undergrad || false,
            gradstudent: this.state.gradstudent || false
          }
        }
      );
    }
  }

  render() {
    if (
      isLoaded(this.props.resource) ||
      this.props.match.params.resourceId === "0"
    ) {
      return (
        <div className="flex-container">
          <div className="toolbar">
            <DrawerToggle /> <h1>Edit Resource</h1> <h1>
              <button onClick={this.save}>
                Save
              </button>
            </h1>
          </div>
          <div className="content log">
            <div className="page ">
              <div className="max-width">
                <div className="card">
                  <h2>
                    Title:
                  </h2>
                  <input
                    disabled={this.props.disabled}
                    type="text"
                    placeholder={"Resource Title"}
                    value={this.state.title}
                    onChange={this.updateTitle}
                  />

                  <h2>
                    Available to:
                  </h2>
                  <div>
                    <input
                      type="checkbox"
                      id="hs"
                      onChange={this.updateHS}
                      defaultChecked={this.state.highschool}
                    />
                    <label htmlFor="hs">Highschool Students</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="ug"
                      onChange={this.updateUG}
                      defaultChecked={this.state.undergrad}
                    />
                    <label htmlFor="ug">Undergraduates</label>
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      id="ms"
                      onChange={this.updateMS}
                      defaultChecked={this.state.gradstudent}
                    />
                    <label htmlFor="ms">Medical Students</label>
                  </div>

                  <h2>Content</h2>

                  <CKEditor
                    value={this.state.content}
                    onChange={this.updateContent}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <BlankPage />;
    }
  }
}

export default withRouter(
  connect(({ firebase }, { match, auth }) => {
    return {
      resource: dataToJS(firebase, `/resources/${match.params.resourceId}`)
    };
  })(
    firebaseConnect(({ match, auth }) => {
      return [`/resources`];
    })(EditResource)
  )
);



// WEBPACK FOOTER //
// ./src/routes/edit-resource/index.js